export const DEBUG = false;

export const REPO_URL = "https://github.com/jaykaron/tanakh-grepper/";
